// extracted by mini-css-extract-plugin
module.exports = {"title":"Contact_title__Ds4ua","phoneText":"Contact_phoneText__3nL10","sectionWithMargin":"Contact_sectionWithMargin__1_1jG"};